module.exports = __webpack_public_path__ + "static/media/footer-tab.14476103.png";